// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors

import type {ShaderModule} from '@luma.gl/shadertools';

const uniformBlockWGSL = /* wgsl */ `\
struct ArcUniforms {
  greatCircle: f32,
  useShortestPath: f32,
  numSegments: f32,
  widthScale: f32,
  widthMinPixels: f32,
  widthMaxPixels: f32,
  widthUnits: i32,
};

@group(0) @binding(auto) var<uniform> arc: ArcUniforms;
`;

const uniformBlock = `\
layout(std140) uniform arcUniforms {
  bool greatCircle;
  bool useShortestPath;
  float numSegments;
  float widthScale;
  float widthMinPixels;
  float widthMaxPixels;
  highp int widthUnits;
} arc;
`;

export type ArcProps = {
  greatCircle: boolean;
  useShortestPath: boolean;
  numSegments: number;
  widthScale: number;
  widthMinPixels: number;
  widthMaxPixels: number;
  widthUnits: number;
};

export const arcUniforms = {
  name: 'arc',
  source: uniformBlockWGSL,
  vs: uniformBlock,
  fs: uniformBlock,
  uniformTypes: {
    greatCircle: 'f32',
    useShortestPath: 'f32',
    numSegments: 'f32',
    widthScale: 'f32',
    widthMinPixels: 'f32',
    widthMaxPixels: 'f32',
    widthUnits: 'i32'
  }
} as const satisfies ShaderModule<ArcProps>;
